interface ErrorItem {
  field: string
  message: string
  value?: string
  fieldPath?: string
}

interface ResponseData {
  errors?: ErrorItem[]
  [key: string]: unknown
}

export default function aggregateResponseErrors(responseData: ResponseData | null | undefined, path: string = ''): ErrorItem[] {
  if (!responseData) {
    return []
  }

  const aggregatedErrors: ErrorItem[] = []

  if (responseData.errors && Array.isArray(responseData.errors)) {
    responseData.errors.forEach((err: ErrorItem) => {
      const errorWithPath = { ...err }
      if (path) {
        errorWithPath.fieldPath = path
      }
      aggregatedErrors.push(errorWithPath)
    })
  }

  for (const key in responseData) {
    if (key !== 'errors' && responseData[key] !== null && typeof responseData[key] === 'object') {
      const currentPath = path ? `${path}.${key}` : key
      const value = responseData[key]

      if (Array.isArray(value)) {
        value.forEach((item: unknown, index: number) => {
          if (item && typeof item === 'object') {
            const itemPath = `${currentPath}[${index}]`
            const nestedErrors = aggregateResponseErrors(item as ResponseData, itemPath)
            aggregatedErrors.push(...nestedErrors)
          }
        })
      } else if (typeof value === 'object') {
        const nestedErrors = aggregateResponseErrors(value as ResponseData, currentPath)
        aggregatedErrors.push(...nestedErrors)
      }
    }
  }

  return aggregatedErrors
}
